// services/leaveRequestApi.ts
import { apiSlice } from "services/apiSlice";

export const leaveRequestApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Récupérer toutes les demandes de congé
    getLeaveRequests: builder.query({
      query: () => "leave-requests",
      providesTags: ["LeaveRequest"],
    }),

    // Récupérer une demande de congé par ID
    getLeaveRequestById: builder.query({
      query: (id) => `leave-requests/${id}`,
      providesTags: ["LeaveRequest"],
    }),

    // Récupérer les demandes par fournisseur
    getLeaveRequestsBySupplier: builder.query({
      query: (supplierId) => `leave-requests/supplier/${supplierId}`,
      providesTags: ["LeaveRequest"],
    }),

    // Récupérer les demandes par collaborateur
    getLeaveRequestsByCollaborator: builder.query({
      query: (collaboratorId) =>
        `leave-requests/collaborator/${collaboratorId}`,
      providesTags: ["LeaveRequest"],
    }),

    getValidatedLeaveRequestsByCollaborator: builder.query({
      query: (collaboratorId) =>
        `leave-requests/collaborator/${collaboratorId}/validated`,
      providesTags: ["LeaveRequest"],
    }),
    // 🔹 NOUVEAU : Récupérer les demandes par validateur
    getLeaveRequestsByValidateur: builder.query({
      query: (validateurId) => `leave-requests/validateur/${validateurId}`,
      providesTags: ["LeaveRequest"],
    }),
    // Créer une nouvelle demande de congé
    createLeaveRequest: builder.mutation({
      query: (data) => ({
        url: "leave-requests",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LeaveRequest"],
    }),

    // Envoyer une demande de congé par email
    sendLeaveRequestEmail: builder.mutation({
      query: (data) => ({
        url: "leave-requests/email",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LeaveRequest"],
    }),

    // Mettre à jour une demande de congé
    updateLeaveRequest: builder.mutation({
      query: ({ id, data }) => ({
        url: `leave-requests/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["LeaveRequest"],
    }),

    // Supprimer une demande de congé
    deleteLeaveRequest: builder.mutation({
      query: (id) => ({
        url: `leave-requests/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["LeaveRequest"],
    }),

    validateLeaveRequest: builder.mutation({
      query: (id) => ({
        url: `leave-requests/validate/${id}`,
        method: "GET",
      }),
      invalidatesTags: ["LeaveRequest"], // pour recharger la liste après validation
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetLeaveRequestsQuery,
  useGetLeaveRequestByIdQuery,
  useGetLeaveRequestsBySupplierQuery,
  useGetLeaveRequestsByCollaboratorQuery,
  useGetValidatedLeaveRequestsByCollaboratorQuery,
  useGetLeaveRequestsByValidateurQuery, // ✅ nouveau hook
  useCreateLeaveRequestMutation,
  useSendLeaveRequestEmailMutation,
  useUpdateLeaveRequestMutation,
  useDeleteLeaveRequestMutation,
  useValidateLeaveRequestMutation,
} = leaveRequestApi;
